import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToolSsoService } from './service/tool-sso.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { SsoInterface } from 'src/app/util/interfaces/sso';
import { faPencil, faTrash } from '@fortawesome/free-solid-svg-icons';
import { catchError } from 'rxjs';

@Component({
	selector: 'register-form-tool-sso',
	templateUrl: './tool-sso.component.html',
	styleUrls: ['./tool-sso.component.scss'],
})
export class ToolSsoComponent implements OnInit {
	labels: any = {
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
		lbl_geral_nome: 'Name',
		lbl_geral_dominio: 'Domain',
		lbl_geral_pagina: 'Homepage',
		lbl_geral_pagina_logout: 'Logout Page',
		lbl_geral_pagina_de_redirecionamento: 'Redirection Page',
		lbl_bulletin_actions: 'actions',
		lbl_geral_atualizar: 'Update',
		lbl_geral_novo_sso: 'New SSO',
		lbl_geral_deletado_com_sucesso: 'Successfully deleted',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_geral_gerenciamento_de_sso: 'SSO Management',
		lbl_geral_criacao_de_sso: 'SSO Creation',
		lbl_geral_atualizacao_de_sso: 'SSO Update',
		lbl_geral_erro_sso_cadastrado: 'lbl_geral_erro_sso_cadastrado',
	};

	icons = {
		faPencil: faPencil,
		faTrash: faTrash,
	};

	isLoadingLabels = true;
	isLoadingSSO = true;
	isUpdating = false;

	showForm = false;
	showEditForm = false;
	searchText = '';

	filteredItems: SsoInterface[] = [];
	ssoList: SsoInterface[] = [];

	sso = {} as SsoInterface;
	form: SsoInterface = {
		customer_name: '',
		customer_hash: '',
		customer_domain: '',
		customer_page: '',
		logout_page: '',
		redirect_page: '',
	};

	formUpdate: SsoInterface = {
		customer_name: '',
		customer_hash: '',
		customer_domain: '',
		customer_page: '',
		logout_page: '',
		redirect_page: '',
	};

	constructor(
		private toolSsoService: ToolSsoService,
		private notificationService: NotificationService,
		private labelsService: LabelsService,
		private cdr: ChangeDetectorRef
	) {}

	selectedTab = 'management';

	ngOnInit() {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getAllSSO();
		this.filteredItems = this.ssoList;
	}

	createSSO(form: SsoInterface): void {
		if (this.isUpdating) return;

		if (!form.customer_name.trim()) {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.isUpdating = true;
		this.toolSsoService
			.postSSO(form)
			.pipe(
				catchError((error) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_erro_sso_cadastrado);
					this.form = {
						customer_hash: '',
						customer_domain: '',
						customer_page: '',
						logout_page: '',
						redirect_page: '',
					};
					this.showForm = false;
					this.isUpdating = false;
					throw error;
				})
			)
			.subscribe(() => {
				this.getAllSSO();
				this.notificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.form = {
					customer_hash: '',
					customer_domain: '',
					customer_page: '',
					logout_page: '',
					redirect_page: '',
				};
				this.showForm = false;
				this.isUpdating = false;
			});
	}

	updateSSO(item: SsoInterface): void {
		if (this.isUpdating) return;

		if (item.customer_name === '') {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		} else {
			this.isUpdating = true;
			this.toolSsoService.updateSSO(item).subscribe(() => {
				this.notificationService.setNotificationMessage(this.labels.lbl_successful_updated);

				const index = this.ssoList.findIndex((index_) => index_.customer_hash === item.customer_hash);
				if (index !== -1) {
					this.ssoList[index] = item;
				}

				// Notifique o Angular para atualizar a exibição
				this.cdr.detectChanges();
				this.showEditForm = false;
				this.isUpdating = false;
			});
		}
	}

	deleteSSO(hash: string) {
		if (this.isUpdating) return;

		this.isUpdating = true;
		const temporaryItem: SsoInterface = { customer_hash: hash };
		this.toolSsoService.deleteSSO(temporaryItem).subscribe(() => {
			this.notificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);

			const index = this.ssoList.findIndex((item) => item.customer_hash === hash);
			if (index !== -1) {
				this.ssoList.splice(index, 1);
			}
			this.isUpdating = false;
		});
	}

	getAllSSO(): void {
		this.toolSsoService.getAllSSO().subscribe((data: SsoInterface[]) => {
			this.ssoList = data;
			this.isLoadingSSO = false;
			this.cdr.detectChanges();
		});
	}

	openUpdatedForm(item: SsoInterface): void {
		this.formUpdate = { ...item };
		this.showEditForm = !this.showEditForm;
	}

	openForm(item: SsoInterface): void {
		this.form = { ...item };
		this.showForm = !this.showForm;
	}

	searchItems(): void {
		const searchText = this.searchText.toLowerCase();
		this.filteredItems = this.ssoList.filter((item) => {
			return (
				(item.customer_domain ?? '').toLowerCase().includes(searchText) ||
				(item.customer_page ?? '').toLowerCase().includes(searchText) ||
				(item.redirect_page ?? '').toLowerCase().includes(searchText) ||
				(item.customer_name ?? '').toLowerCase().includes(searchText) ||
				(item.customer_hash ?? '').toLowerCase().includes(searchText) ||
				(item.logout_page ?? '').toLowerCase().includes(searchText)
			);
		});
	}

	confirmButton(elementReference: HTMLElement): void {
		this.notificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirm');
		setTimeout(() => {
			elementReference.classList.remove('confirm');
		}, 5000);
	}
}
